import React, { useState } from 'react';
import { Button, Card, Col, Descriptions, Form, Input, Modal, notification, Popconfirm, Row, Select } from 'antd';
import Title from 'antd/es/typography/Title';
import { CustomSelector } from '../../../components';
import { getStructureTypes } from '../../../api/module/structure';
import { SearchOutlined } from '@ant-design/icons';
import AjaxTable from '../../../components/AjaxTable';
import { queryUnit as filterUnit } from '../../../api/module/unit';
import MESSAGES from '../../../enums/Messages';
import { createUnitFormMassive } from '../../../api/module/unit_form';


export default function BindUnitsToForms({ project, parentModalBindUnit, responseBindUnit, forms = []}) {
  const [formSearchUnits] = Form.useForm();
  const [modalBindUnit, setModalBindUnit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [queryUnits, setQueryUnits] = useState("filter[proyecto]="+project);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [reloadUnit, setReloadUnit] = useState(false);

  const columnsUnit = [
    {
      title: 'Tipo Estructura',
      dataIndex: 'nombre_estructura',
      key: 'nombre_estructura',
    },
    {
      title: 'Detalle 1',
      dataIndex: 'detalle1',
      key: 'detalle1',
    },
    {
      title: 'Detalle 2',
      dataIndex: 'detalle2',
      key: 'detalle2',
    },
    {
      title: 'Detalle 3',
      dataIndex: 'detalle3',
      key: 'detalle3',
    },
    {
      title: 'Detalle 4',
      dataIndex: 'detalle4',
      key: 'detalle4',
    },
    {
      title: 'Estado',
      dataIndex: 'unidad_activo',
      key: 'unidad_activo',
      render: (text) => (text ? 'A' : 'I'),
    },
  ];

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleReset = () => {
    formSearchUnits.resetFields();
    setModalBindUnit(false);
    setSelectedRowKeys([]);
    parentModalBindUnit(false);
  };

  const searchUnits = async (values) => {
    setReloadUnit(false);
    let params = Object.entries(values).filter(([_, value]) => value !== undefined)
      .reduce((pv, cv) => {
        pv[`filter[${cv[0]}]`] = cv[1];
        return pv;
      },{});
    params['filter[proyecto]'] = project;
    const query = new URLSearchParams(params).toString();
    setQueryUnits(query);
  };

  const bindFormsUnits = async () => {
    if (selectedRowKeys.length > 0) {
      try {
        let data = [];
        forms.forEach(f => {
          selectedRowKeys.forEach(u => {
            data.push({ "formulario": f, "unidad": u, "proyecto": project });
          });
        });
        await createUnitFormMassive(data);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 3,
        });
      } catch (error) {
        console.log(error);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_POST_MSG,
          duration: 3,
        });
      } finally {
        handleReset();
        responseBindUnit();
      }
    } else {
      notification.warning({
        message: "Persona Requerida",
        description: "Debe seleccionar al menos una unidad para poder asignar a formularios.",
        duration: 3,
      });
    }
  };

  return(
    <Modal
      title='Vincular Unidades a Formularios'
      open={modalBindUnit}
      onCancel={handleReset}
      footer={null}
      width={'70%'}
      destroyOnClose
    >
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <Descriptions
            column={1}
            bordered
            size="small"
          >
            <Descriptions.Item label="Formularios Seleccionadas:">
              {forms.length}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form
            form={formSearchUnits}
            name="units_search_form_modal"
            layout="vertical"
            onFinish={searchUnits}
          >
            <Card
              variant='borderless'
              title={<Title level={5}>Búsqueda de Unidades</Title>}
            >
              <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                <Col span={12}>
                  <Form.Item
                    label="Tipo de unidad:"
                    name="tipo_estructura"
                  >
                    <CustomSelector
                      selectorProps={{
                        label: "Tipo de unidad:",
                        style: { width: '100%' },
                        placeholder:
                          'Seleccione el tipo de unidad... ',
                      }}
                      endpointFetch={async () => {
                        return await getStructureTypes();
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item
                    label="Estado"
                    name="activo"
                    placeholder="Activos / Inactivos"
                  >
                    <Select>
                      <Select.Option value="1">Activo</Select.Option>
                      <Select.Option value="0">Inactivo</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                <Col span={12}>
                  <Form.Item label="Detalle 1" name="detalle1">
                    <Input
                      allowClear
                      placeholder="Búsqueda por valor de detalle 1"
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item label="Detalle 2" name="detalle2">
                    <Input
                      allowClear
                      placeholder="Búsqueda por valor de detalle 2"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'space-around'} style={{ marginTop: '10px' }}>
                <Col span={12}>
                  <Form.Item label="Detalle 3" name="detalle3">
                    <Input
                      allowClear
                      placeholder="Búsqueda por valor de detalle 3"
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item label="Detalle 4" name="detalle4">
                    <Input
                      allowClear
                      placeholder="Búsqueda por valor de detalle 4"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item wrapperCol={{ span: 24 }}>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  htmlType="submit"
                  loading={loading}
                >Buscar</Button>
                <Button
                  style={{ marginLeft: '20px' }}
                  danger
                  onClick={() => {
                    formSearchUnits.resetFields();
                    setQueryUnits("filter[proyecto]="+project);
                  }}
                >Borrar filtros</Button>
              </Form.Item>
            </Card>
          </Form>
        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <AjaxTable
            tableTitle={'Listado de unidades asignadas al proyecto'}
            rowKey={'id'}
            rowSelection={rowSelection}
            endpoint={filterUnit}
            query={queryUnits}
            columns={columnsUnit}
            searchInput={true}
            reloadSource={reloadUnit}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '15px' }} justify={'center'}>
        <Col>
          <Popconfirm
            title='Confirmación de asignación'
            description={`Se asignaran ${selectedRowKeys.length} unidades a ${forms.length} formularios. Esta Seguro(a) de continuar ?`}
            onConfirm={bindFormsUnits}
            okText='Confirmar'
            cancelText='Cancelar'
          >
            <Button type="primary">
              Vincular unidades seleccionadas a formularios
            </Button>
          </Popconfirm>
        </Col>
        <Col style={{ marginLeft: '20px' }}>
          <Button
            onClick={() => handleReset()}
            danger
          >Volver</Button>
        </Col>
      </Row>
    </Modal>
  );
}
